import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { OrgUnit } from './OrgUnit';
import { ACCESSIBLE_EVENT_NODE_IDS, ADMIN_NODE_AND_DESCENDANTS, EVENTS_I_HOST } from './SecurityRules';

export interface OrgUnitEventRow {
  id: number;
  event_id: number;
  org_unit_id: number;
  source_type: string;
  source_id: number | null;
  created_at: string;
}

export const OrgUnitEvent: Entity<OrgUnitEventRow> = {
  id: 'OrgUnitEvent',
  title: 'Org Unit Event',
  service: 'main',
  rowLabel: (row: OrgUnitEventRow) => [row.event_id, row.org_unit_id].join(' / '),
  rowLabelDynamic: (row: OrgUnitEventRow) => `<lookup:Event:${row.event_id}> / <lookup:OrgUnit:${row.org_unit_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.org_unit_event',
  },
  security: [
    { role: 'user', action: 'read', access: 'conditional', condition: `event_id IN ${ACCESSIBLE_EVENT_NODE_IDS}` },
    {
      role: 'user',
      action: 'update',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HOST} OR org_unit_id IN ${ADMIN_NODE_AND_DESCENDANTS}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['event_id', 'ASC']],
  defaultFilters: [{ fieldId: 'event_id', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    event_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Event',
      mandatory: true,
      listColumn: true,
      refEntity: Event,
    },
    org_unit_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'Org Unit',
      mandatory: true,
      listColumn: true,
      refEntity: OrgUnit,
    },
    source_type: {
      seq: 20,
      type: FieldType.Text,
      label: 'Source Type',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
    },
    source_id: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Source Id',
      persistence: PersistenceType.BackEndManaged,
    },
    created_at: {
      seq: 30,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
